import React, {useEffect, useState} from 'react';
import AppContainer from "../../components/AppContainer";
import {useNavigate} from "react-router-dom";
import OpsBtn from "../../ops-library/ops-btn";
import OpsLogo from "../../ops-library/ops-logo";
import {BackgroundImages} from "../../components/AuthBackground";
import OpsText from "../../ops-library/ops-text";
import OpsInput from "../../ops-library/ops-input";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {isTokenExpired} from "../../functions/isTokenExpired";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import validator from 'validator';
import {Form} from "react-bootstrap";
import {AuthLoadingSpinner} from "../../components/AuthLoadingSpinner";

const Recovery = () => {

    const navigate = useNavigate()
    const [userEmail, setUserEmail] = useState("");
    const [processed, setProcessed] = useState(false)
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    useEffect(() => {
        if (token && !isTokenExpired(token)) {
            navigate("/")
        }
    }, []);
    const PasswordRecovery = () => {

        const [email, setEmail] = useState('');
        const [errorEmail, setErrorEmail] = useState(false);

        function handleRecovery(e) {
            e.preventDefault();

            if (email.length === 0) {
                opsToast("Nezadali ste email používateľa!", "error", "colored", true, "top-center")
                setErrorEmail(true);
            } else if (!validator.isEmail(email)) {
                opsToast("Nesprávny email!", "error", "colored", true, "top-center")
                setErrorEmail(true);
            } else {
                setProcessed(true)
                setUserEmail(email)
                const configuration = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/recovery`,
                    data: {
                        email
                    },
                };
                setProcessed(false)
                axios(configuration)
                    .then((result) => {
                        document.getElementById("recovery").style.display = "none"
                        document.getElementById("recovered").style.display = "flex"
                        setErrorEmail(false);
                    })
                    .catch((error) => {
                        setErrorEmail(true);
                        setProcessed(false)
                        console.log(error)
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                    });
            }
        }

        function handleBack() {
            navigate(-1);
        }

        return (
            <div className="account-tab-container px-2 py-3 rounded-5 shadow-sm" id="recovery">
                <div className="account-tab-content">
                    <OpsBtn
                        btnBack
                        text="Späť"
                        variant="back"
                        backgroundColor="bg-transparent"
                        textColor="color-g-1"
                        textSize="bg"
                        action={() => handleBack()}
                    />

                    <div className="fa-flex-col align-items-center mt-4 w-100">
                        <OpsLogo size="bg pointer-cursor" action={() => navigate("/")}/>
                        <OpsText type="title" className="fa-w-70 mt-4"
                                 content={"Obnovenie hesla"}/>
                    </div>

                    <OpsText className="fa-w-80 mt-5"
                             content={"Ak ste zabudli svoje heslo alebo login, kontaktujte administrátora aplikácie, ktorý vám podá potrebné inštrukcie pre obnovenie hesla."}
                    />
                    <OpsBtn
                        btnText
                        text="betarkyweb@gmail.com"
                        action={() => null}
                    />

                    {/*<Form className="login-form fa-w-80 mb-3"*/}
                    {/*      onSubmit={(e) => handleRecovery(e)}>*/}
                    {/*    <OpsInput*/}
                    {/*        error={errorEmail}*/}
                    {/*        required*/}
                    {/*        id="email"*/}
                    {/*        label="E-mail"*/}
                    {/*        placeholder="Zadajte e-mailovú adresu"*/}
                    {/*        value={email}*/}
                    {/*        onChange={(e) => {*/}
                    {/*            setEmail(e.target.value)*/}
                    {/*            setErrorEmail(false)*/}
                    {/*        }}*/}
                    {/*    />*/}

                    {/*    <OpsBtn*/}
                    {/*        text="Obnoviť heslo"*/}
                    {/*        type="submit"*/}
                    {/*        size="md"*/}
                    {/*        textSize="sm"*/}
                    {/*        variant=" w-100 mt-3"*/}
                    {/*        action={(e) => handleRecovery(e)}*/}
                    {/*    />*/}
                    {/*</Form>*/}

                    {/*<div className="fa-flex-col gap-1">*/}
                    {/*    <OpsText weight={300}*/}
                    {/*             content={"Nepamätáš si emailovú adresu?"}/>*/}
                    {/*    <OpsBtn*/}
                    {/*        btnText*/}
                    {/*        text="Kontaktuj našu podporu"*/}
                    {/*        action={() => navigate("/kontakty")}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            </div>
        )

    }
    const PasswordRecovered = () => {

        return (
            <div className="account-tab-container px-2 py-3 rounded-5 shadow-sm" id="recovered">
                <div className="account-tab-content">
                    <div className="fa-flex-col align-items-center mt-4 w-100">
                        <OpsLogo size="bg pointer-cursor" action={() => navigate("/")}/>
                        <OpsText type="title" className="fa-w-70 mt-4"
                                 content={"Obnovenie hesla"}/>
                    </div>

                    <OpsText className="fa-w-80 mt-5" renderWithLine={false} content={
                        <>
                            <span>{"Na vašu emailovú adresu "}</span>
                            <span className="font-700">{userEmail}</span>
                            <span>{" sme vám poslali inštrukcie pre obnovenie hesla."}</span>
                        </>
                    }/>

                    <OpsBtn text="Prihlásiť sa" variant="primary fa-w-80 mb-3 mt-5"
                            action={() => navigate("/prihlasenie")}/>
                </div>
            </div>
        )
    }

    return (
        <AppContainer
            showFooter={false}
            showNavbar={false}
            content={
                <div className="window-login-container">
                    <BackgroundImages/>
                    {processed ?
                        <AuthLoadingSpinner/>
                        :
                        <>
                            <PasswordRecovery/>
                            <PasswordRecovered/>
                        </>
                    }
                </div>
            }
        />
    );
};

export default Recovery;